import React from 'react';
import useAxios from 'axios-hooks';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';

import { IStaticInfos } from '../types/strapi';

const useStyles = makeStyles((theme) => ({
  image: {
    position: 'relative',
    display: 'flex',
    [theme.breakpoints.down('xs')]: {
      display: 'block',
    },
    '& .image': { width: '100%' },
    '& .text': {
      bottom: '0',
      left: '0',
      color: '#0a1c1f',
      position: 'absolute',
      fontSize: '27px',
      fontWeight: '600',
      letterSpacing: '0.5px',
      width: '50%',
      height: '60%',
      padding: '3% 5%',
      lineHeight: 2,
      backgroundColor: '#ffffffbf',
      [theme.breakpoints.down('md')]: {
        fontSize: '21px',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '18px',
        padding: '2%',
      },
      [theme.breakpoints.down('xs')]: {
        position: 'relative',
        width: '100%',
      },
    },
  },
}));

const Negozio: React.FC = () => {
  const classes = useStyles();

  const [{ data: staticInfos }] = useAxios<IStaticInfos>('static-info');

  return (
    <Container disableGutters>
      <Box className={classes.image}>
        <img className="image" src={staticInfos ? staticInfos.negozioImage.url : ''} alt="" />
        <div className="text">
          Concediti un momento di relax in aperta campagna! Nel nostro negozio “fisico” puoi trovare{' '}
          <b>delizie e primizie di stagione</b>: la nostra frutta e i nostri ortaggi migliori ma anche prodotti
          confezionati da noi come <b>le mostarde, le confetture e la pasta fatta in casa</b>.
        </div>
      </Box>
    </Container>
  );
};

export default Negozio;
